import React from 'react';
import * as styles from './index.module.less';
import { PublicArrowDownOutlined } from 'notta-web-icon';

interface IProps {
  label: string;
  link?: string;
  isDropdownActive?: boolean;
}

const NavbarItemWrapper = ({ label, link, isDropdownActive = false }: IProps) => {
  return link ? (
    <a href={link} className={styles.nav_bar_link}>
      {label}
    </a>
  ) : (
    <button className={`${styles.nav_bar_btn} ${isDropdownActive && styles.active}`}>
      {label}
      <PublicArrowDownOutlined className={styles.nav_bar_btn_arrow} />
    </button>
  );
};
export default NavbarItemWrapper;
